/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manager_Question_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Choose your manager" |
*
* @param {Manager_Question_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const manager_question_placeholder = /** @type {((inputs?: Manager_Question_PlaceholderInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manager_Question_PlaceholderInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Kies je leidinggevende")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisissez votre responsable")
	return /** @type {LocalizedString} */ ("Choose your manager")
});